export const baseurl = 'https://digitalize.aiyd88.com'
export const appid = 'wxef7287bb04229749'